
    var doc = {"kind":"Document","definitions":[{"kind":"EnumTypeDefinition","name":{"kind":"Name","value":"WikiDiscussionSortOrder"},"directives":[],"values":[{"kind":"EnumValueDefinition","name":{"kind":"Name","value":"CREATED_ASC"},"directives":[]},{"kind":"EnumValueDefinition","name":{"kind":"Name","value":"CREATED_DESC"},"directives":[]}]},{"kind":"ObjectTypeExtension","name":{"kind":"Name","value":"Query"},"interfaces":[],"directives":[],"fields":[{"kind":"FieldDefinition","name":{"kind":"Name","value":"wikiDiscussionSortOrder"},"arguments":[],"type":{"kind":"NamedType","name":{"kind":"Name","value":"WikiDiscussionSortOrder"}},"directives":[]}]},{"kind":"ObjectTypeExtension","name":{"kind":"Name","value":"Mutation"},"interfaces":[],"directives":[],"fields":[{"kind":"FieldDefinition","name":{"kind":"Name","value":"sortWikiDiscussion"},"arguments":[{"kind":"InputValueDefinition","name":{"kind":"Name","value":"by"},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WikiDiscussionSortOrder"}},"directives":[]}],"type":{"kind":"NamedType","name":{"kind":"Name","value":"WikiDiscussionSortOrder"}},"directives":[]}]}],"loc":{"start":0,"end":237}};
    doc.loc.source = {"body":"enum WikiDiscussionSortOrder {\n  CREATED_ASC\n  CREATED_DESC\n}\n\nextend type Query {\n  wikiDiscussionSortOrder: WikiDiscussionSortOrder\n}\n\nextend type Mutation {\n  sortWikiDiscussion(by: WikiDiscussionSortOrder): WikiDiscussionSortOrder\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
